import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight, Plus, Minus, Trash2 } from "lucide-react";
import { imgUrl, money } from "../api";
import { useCart } from "../context/CartContext";
import { formatDeliveryTime } from "../utils/whatsappBill";

export default function Cart() {
  const { cart, updateQty, removeFromCart, cartTotal } = useCart();
  const navigate = useNavigate();

  return (
    <main className="page cart-page" data-testid="cart-page">
      <div className="page-head">
        <span className="eyebrow">Your selection</span>
        <h1>
          Order <em>review.</em>
        </h1>
      </div>
      {cart.length ? (
        <div className="cart-layout">
          <div>
            {cart.map((x, i) => (
              <div className="cart-line" key={`${x.product_id}-${x.size}-${x.color}-${i}`} data-testid={`cart-row-${i}`}>
                <img src={imgUrl(x.image)} alt={x.name} />
                <div>
                  <span className="meta">
                    Size {x.size}
                    {x.color ? ` · ${x.color}` : ""}
                  </span>
                  <h3>{x.name}</h3>
                  <span className="cart-delivery-time">Estimated delivery: {formatDeliveryTime(x.delivery_time_days)}</span>
                  <div className="price">{money(x.price)}</div>
                </div>
                <div className="qty-ctrl">
                  <button onClick={() => updateQty(i, -1)} data-testid={`decrease-quantity-${i}`} aria-label="Decrease">
                    <Minus size={13} />
                  </button>
                  <span data-testid={`quantity-${i}`}>{x.quantity}</span>
                  <button onClick={() => updateQty(i, 1)} data-testid={`increase-quantity-${i}`} aria-label="Increase">
                    <Plus size={13} />
                  </button>
                </div>
                <div className="price">{money(x.price * x.quantity)}</div>
                <button className="remove-btn" onClick={() => removeFromCart(i)} aria-label="Remove" data-testid={`remove-cart-item-${i}`}>
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
          <aside className="cart-summary">
            <h2>Summary</h2>
            <div className="row">
              <span>Items</span>
              <span>{cart.reduce((a, x) => a + x.quantity, 0)}</span>
            </div>
            <div className="row">
              <span>Subtotal</span>
              <strong data-testid="cart-subtotal">{money(cartTotal)}</strong>
            </div>
            <div className="row total">
              <span>Total</span>
              <strong>{money(cartTotal)}</strong>
            </div>
            <p>Payment is arranged directly with the studio after your WhatsApp enquiry. No card charge here.</p>
            <button className="btn btn-primary btn-full" onClick={() => navigate("/checkout")} data-testid="review-order-button">
              Continue to details <ArrowUpRight size={16} />
            </button>
          </aside>
        </div>
      ) : (
        <div className="empty">
          <p data-testid="empty-cart-message" style={{ marginBottom: 30 }}>Your selection is waiting to be made.</p>
          <Link to="/shop" className="btn btn-primary" data-testid="empty-cart-shop-button">
            Explore the collection <ArrowUpRight size={16} />
          </Link>
        </div>
      )}
    </main>
  );
}
